export default "<map-widget></map-widget>";